// extracted by mini-css-extract-plugin
module.exports = {"item":"CountryPicker_item__3CISs","icon":"CountryPicker_icon__3FUaZ"};